import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        customizedCity: [],
        searchCharts: [], // suggestion The sorting display rules for 
        isExactSearch: false,
        propertyConfigs: [],
        keywordType: '',
        keyword: '',
        searchData: [], //  Middle platform 
        showLocation: false, //  Middle platform 
        locationSuggestionUrl: '', //  Middle platform ,
        locationPlaceholder: ''
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
